import React from 'react'
import type { Conclusion, EventConclusionDetails } from '@fs/zion-tree-types'
import { useTranslation } from 'react-i18next'
import { BillboardText, colors, Paragraph } from '@fs/zion-ui'

type StandardizeWarningProps = {
  conclusion: Conclusion
  hideDate?: boolean
  hidePlace?: boolean
}

export default function StandardizeWarning({
  conclusion,
  hideDate,
  hidePlace,
}: StandardizeWarningProps): JSX.Element | null {
  const [t] = useTranslation()

  const { date, place } = conclusion.details as EventConclusionDetails

  // Determines which text to show - if a date or place doesn't exist, we don't show the warning at all
  let label = ''
  const dateStandardizedOrEmpty = date?.originalText ? !!date?.formalText || hideDate : true
  const placeStandardizedOrEmpty = place?.originalText ? !!place?.normalizedText || hidePlace : true
  if (!dateStandardizedOrEmpty && !placeStandardizedOrEmpty) {
    label = t('conclusion.nonstandardized.date-and-place')
  } else if (!dateStandardizedOrEmpty) {
    label = t('conclusion.nonstandardized.date')
  } else if (!placeStandardizedOrEmpty) {
    label = t('conclusion.nonstandardized.place')
  } else {
    return null
  }
  return (
    <BillboardText data-testid="conclusion:standards-warning" primaryColor={colors.danger60}>
      <Paragraph size="sm">{label}</Paragraph>
    </BillboardText>
  )
}
